module.exports = __webpack_public_path__ + "images/knrm4da78e0f4a15ef3cb3e8cdc2f49b3d42.png";